export const GPT_IMPRESSION_DISCLOSURE =
  "GPT-generated draft; wording is non-deterministic. Radiologist review required.";

export const IMPRESSION_UNAVAILABLE_NOTICE =
  "No Impression could be generated for this report. This draft is incomplete: it contains Findings only.";
